import React from 'react'

export default function AboutWorkout() {
  return (
    <div className="outerWorkout">
  <div className="workout">
    <h1 className="tagline" style={{
      fontSize: '2rem',
      fontWeight: '900',
      color: 'var(--accent-gold)',
      letterSpacing: '1px',
      marginBottom: '20px'
    }}>👊 ABOUT TOOLISO</h1>
    
    <h3 style={{color:"white"}}>We Don't Just Code. We Create Competitive Advantage.</h3>
    <p style={{color:"white"}}>Tooliso is where serious businesses go to build seriously powerful software. From fast-moving startups to forward-thinking enterprises, we partner with visionaries to craft custom platforms, apps, and systems that make money, save time, and scale without limits.</p>
    <p style={{color:"white", fontStyle: 'italic', marginTop: '20px'}}>We're not your average dev shop. We're product-minded technologists obsessed with ROI, speed, and results.</p>
  </div>
</div>
  )
}
